export default "__VITE_ASSET__Bn7Os2fT__"